'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var cn = require('classnames');
var mergeRefs = require('react-merge-refs');
var hooks = require('@alfalab/hooks');
var coreComponentsButton = require('@alfalab/core-components-button/dist/cssm');
var coreComponentsFormControl = require('@alfalab/core-components-form-control/dist/cssm');
var styles = require('./index.module.css');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var cn__default = /*#__PURE__*/_interopDefaultLegacy(cn);
var mergeRefs__default = /*#__PURE__*/_interopDefaultLegacy(mergeRefs);
var styles__default = /*#__PURE__*/_interopDefaultLegacy(styles);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign = function () {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var Input = React__default['default'].forwardRef(function (_a, ref) {
    var _b, _c;
    var _d = _a.size, size = _d === void 0 ? 's' : _d, _e = _a.type, type = _e === void 0 ? 'text' : _e, _f = _a.block, block = _f === void 0 ? false : _f, bottomAddons = _a.bottomAddons, dataTestId = _a.dataTestId, _g = _a.clear, clear = _g === void 0 ? false : _g, disabled = _a.disabled, error = _a.error, success = _a.success, hint = _a.hint, className = _a.className, fieldClassName = _a.fieldClassName, inputClassName = _a.inputClassName, labelClassName = _a.labelClassName, addonsClassName = _a.addonsClassName, focusedClassName = _a.focusedClassName, filledClassName = _a.filledClassName, label = _a.label, leftAddons = _a.leftAddons, onFocus = _a.onFocus, onBlur = _a.onBlur, onChange = _a.onChange, onClear = _a.onClear, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, rightAddons = _a.rightAddons, value = _a.value, defaultValue = _a.defaultValue, wrapperRef = _a.wrapperRef, readOnly = _a.readOnly, restProps = __rest(_a, ["size", "type", "block", "bottomAddons", "dataTestId", "clear", "disabled", "error", "success", "hint", "className", "fieldClassName", "inputClassName", "labelClassName", "addonsClassName", "focusedClassName", "filledClassName", "label", "leftAddons", "onFocus", "onBlur", "onChange", "onClear", "onClick", "onMouseDown", "onMouseUp", "rightAddons", "value", "defaultValue", "wrapperRef", "readOnly"]);
    var uncontrolled = value === undefined;
    var inputRef = React.useRef(null);
    var focusVisible = hooks.useFocus(inputRef, 'keyboard')[0];
    var _h = React.useState(false), focused = _h[0], setFocused = _h[1];
    var _j = React.useState(defaultValue || ''), stateValue = _j[0], setStateValue = _j[1];
    var filled = Boolean(uncontrolled ? stateValue : value);
    // отображаем крестик только для заполненного и активного инпута
    var clearButtonVisible = clear && filled && !disabled && !readOnly;
    var handleInputFocus = React.useCallback(function (event) {
        if (!readOnly) {
            setFocused(true);
        }
        if (onFocus) {
            onFocus(event);
        }
    }, [onFocus, readOnly]);
    var handleInputBlur = React.useCallback(function (event) {
        setFocused(false);
        if (onBlur) {
            onBlur(event);
        }
    }, [onBlur]);
    var handleInputChange = React.useCallback(function (event) {
        if (onChange) {
            onChange(event, { value: event.target.value });
        }
        if (uncontrolled) {
            setStateValue(event.target.value);
        }
    }, [onChange, uncontrolled]);
    var handleClear = React.useCallback(function (event) {
        if (!clearButtonVisible)
            return;
        if (uncontrolled) {
            setStateValue('');
        }
        if (onClear) {
            onClear(event);
        }
        if (inputRef.current && !focused) {
            inputRef.current.focus();
        }
    }, [clearButtonVisible, focused, onClear, uncontrolled]);
    var renderRightAddons = function () {
        var addonsVisible = clearButtonVisible || rightAddons || error || success;
        return (addonsVisible && (React__default['default'].createElement(React.Fragment, null,
            clearButtonVisible && (React__default['default'].createElement(coreComponentsButton.Button, { type: 'button', view: 'ghost', disabled: disabled, "aria-label": '\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C', className: styles__default['default'].clearButton, onClick: handleClear },
                React__default['default'].createElement("span", { className: styles__default['default'].clearIcon }))),
            error && React__default['default'].createElement("span", { className: styles__default['default'].errorIcon }),
            success && !error && React__default['default'].createElement("span", { className: styles__default['default'].successIcon }),
            rightAddons)));
    };
    return (React__default['default'].createElement(coreComponentsFormControl.FormControl, { ref: wrapperRef, className: cn__default['default'](className, focused && focusedClassName, filled && filledClassName), fieldClassName: cn__default['default'](fieldClassName, (_b = {},
            _b[styles__default['default'].focusVisible] = focusVisible,
            _b)), labelClassName: labelClassName, addonsClassName: addonsClassName, size: size, block: block, disabled: disabled, filled: filled || focused, focused: focused, error: error, label: label, hint: hint, leftAddons: leftAddons, rightAddons: renderRightAddons(), bottomAddons: bottomAddons, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp },
        React__default['default'].createElement("input", __assign({}, restProps, { className: cn__default['default'](styles__default['default'].input, (_c = {},
                _c[styles__default['default'].hasLabel] = label,
                _c), inputClassName), disabled: disabled, onBlur: handleInputBlur, onFocus: handleInputFocus, onChange: handleInputChange, ref: mergeRefs__default['default']([ref, inputRef]), type: type, value: uncontrolled ? stateValue : value, readOnly: readOnly, "data-test-id": dataTestId, "aria-label": typeof label === 'string' ? label : undefined }))));
});
/**
 * Для отображения в сторибуке
 */
Input.defaultProps = {
    size: 's',
    type: 'text',
    block: false,
};

exports.Input = Input;
